/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Try_AgainInputs */

const en_gb2_action_try_again = /** @type {(inputs: Action_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const fr_action_try_again = /** @type {(inputs: Action_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Action_Try_AgainInputs} inputs
* @param {{ locale?: "en-GB" | "fr" }} options
* @returns {LocalizedString}
*/
export const action_try_again = /** @type {((inputs?: Action_Try_AgainInputs, options?: { locale?: "en-GB" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Try_AgainInputs, { locale?: "en-GB" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_action_try_again(inputs)
	return en_gb2_action_try_again(inputs)
});